import { Box, Typography } from "@mui/material";
import './index.css';
import { theme } from "../../common/style/Theme";

const WaveCard = (props) => {
  return (
    <Box style={{
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 50px",
      position: "relative",
      cursor: "pointer",
    }} onClick={props.onClick}>
      <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 690" style={{
        transform: "rotate(180deg)",
        position: "relative",
      }}>
        <defs>
          <pattern id={`img-${props.index}`} patternUnits="userSpaceOnUse" width="1440" height="690">
            <image 
              href={props.image} 
              width="1440" 
              height="690" 
              transform="rotate(-180 720 350)"
              preserveAspectRatio="xMidYMid slice"
            />
          </pattern>
        </defs>
        <path d="M 0,700 L 0,337 C 97.20574162679426,325.22966507177034 194.41148325358853,313.4593301435407 286,311 C 377.58851674641147,308.5406698564593 463.5598086124402,315.39234449760767 557,277 C 650.4401913875598,238.60765550239233 751.3492822966507,154.97129186602868 844,138 C 936.6507177033493,121.02870813397132 1021.0430622009569,170.72248803827753 1119,165 C 1216.956937799043,159.27751196172247 1328.4784688995214,98.13875598086123 1440,37 L 1440,700 L 0,700 Z"
          stroke="none" 
          strokeWidth="0" 
          fill={`url(#img-${props.index})`}
          fillOpacity="1"
        />
        <path d="M 0,700 L 0,337 C 97.20574162679426,325.22966507177034 194.41148325358853,313.4593301435407 286,311 C 377.58851674641147,308.5406698564593 463.5598086124402,315.39234449760767 557,277 C 650.4401913875598,238.60765550239233 751.3492822966507,154.97129186602868 844,138 C 936.6507177033493,121.02870813397132 1021.0430622009569,170.72248803827753 1119,165 C 1216.956937799043,159.27751196172247 1328.4784688995214,98.13875598086123 1440,37 L 1440,700 L 0,700 Z"
          stroke="none" 
          strokeWidth="0" 
          fill={theme.palette.primary.main} 
          fillOpacity="0.65"
        />
      </svg>
      <Typography variant="h5" style={{
        fontWeight: "bold",
        color: theme.palette.common.white,
        position: "absolute",
        top: "20px",
        left: "20px",
        zIndex: 2,
      }}>
          {props.title}
      </Typography>
      <Box style={{
        marginTop: "-30px",
        padding: "5px 20px 20px 20px",
        height: "250px"
      }}>
        <Typography variant="body1" style={{ marginTop: "10px" }}>
          {props.description}
        </Typography>
      </Box>
    </Box>
  );
};

export default WaveCard;
